declare var ga: (
  command: string,
  hitType: string | object,
  eventCategory?: string,
  eventAction?: string,
  eventLabel?: string,
  eventValue?: any,
) => void;

export default class LogEvent {
  private instance: string;
  public setInstance(instance: string) {
    this.instance = instance;
  }

  /**
   * A página é aberta.
   */
  public open() {
    this.sendEvent('open');
    this.sendTiming('open');
  }

  /**
   * A Aplicação inicia a pesquisa
   */
  public start() {
    this.sendEvent('start');
    this.sendTiming('start');
  }

  /**
   * O usuáro escolhe uma nota
   * @param rating qual nota
   */
  public rate(rating: number) {
    this.sendEvent('rate', rating);
    this.sendTiming('rate');
  }

  /**
   * A Aplicação registra uma nota parcial
   * @param rating qual nota
   */
  public partial(rating: number) {
    this.sendEvent('partial', rating);
    this.sendTiming('partial');
  }

  /**
   * O usuário avalia todos os itens
   */
  public items() {
    this.sendEvent('items');
    this.sendTiming('items');
  }

  /**
   * A aplicação mostra um erro de validação para o usuário,
   *  por exemplo: algum item faltando avaliar.
   * @param message qual mensagem exibida
   */
  public validation(message: string) {
    this.sendEvent('validation ' + message);
  }

  /**
   * A aplicação exibe algum erro
   * @param error Erro exibido
   */
  public error(error: string) {
    this.sendEvent('Error: ' + error);
  }

  /**
   * O usuário adiciona um comentário
   */
  public comment() {
    this.sendEvent('comment');
  }

  /**
   * O usuário marcou a avaliação como anônima
   * @param status marcado ou não
   */
  public anonym(status: boolean = true) {
    this.sendEvent('anonym' + (!status ? ' false' : ''));
  }

  /**
   * O usuário preenchei enriquecimento
   * @param status preenchido ou não
   */
  public enrichment(status: boolean = true) {
    this.sendEvent('enrichment' + (!status ? ' false' : ''));
  }

  /**
   * O usuário tocou em "completar" avaliação
   */
  public complete() {
    this.sendEvent('complete');
    this.sendTiming('complete');
  }

  /**
   * A aplicação completa a avaliação e mostra tela de obrigado
   */
  public done() {
    this.sendEvent('done');
    this.sendTiming('done');
  }

  /**
   * O usuário saiu da página sem concluir a avaliação
   */
  public giveUp() {
    this.sendEvent('giveup');
    this.sendTiming('giveup');
  }

  /**
   * O usuário clicou no Link da SoluCX no rodapé
   */
  public link() {
    this.sendEvent('link solucx');
  }

  /**
   * O usuário clicou no Link da SoluCX no rodapé
   */
  public unsubscribe() {
    this.sendEvent('unsubscribe');
  }

  /**
   * O usuário clicou no Link da SoluCX no rodapé
   */
  public unsubscribeReason(reason: string) {
    this.sendEvent('unsubscribe - ' + reason);
  }

  /**
   * Send the event to Google Analytics
   * @param action event action
   * @param value  event value
   */
  private sendEvent(action: string, value: any = null) {
    // only if ga is defined
    if (typeof ga === 'function') {
      ga('send', 'event', 'survey', action, this.instance, value);
    }
  }

  private sendTiming(name: string) {
    // only if ga is defined
    if (typeof ga === 'function') {
      if (!performance) return;
      if (location.hostname === 'localhost') return;
      const time: number = performance.now();
      if (time > 0) {
        ga('send', {
          hitType: 'timing',
          timingCategory: 'Performance Metrics',
          timingVar: name,
          timingValue: Math.round(time),
        });
      }
    }
  }
}
